<template>
    <ValidationProvider :vid="$attrs.vid" :name="$attrs.vid" :rules="rules" v-slot="{errors}">
        <div class="checkbox-container">
            <template v-if="multiple">
                    <template v-if="$attrs.orientation == 'inline'">
                            <div class="custom-control custom-checkbox custom-control-inline" v-for="(dt,index) in data" v-bind:key="index">
                                <input type="checkbox" class="custom-control-input" v-model="selected" :id="`cb-${$attrs.vid}-${dt.value}`" :value="dt.value"  :disabled="disabled">
                                <label class="custom-control-label" :for="`cb-${$attrs.vid}-${dt.value}`">{{dt.label}}</label>
                            </div>
                    </template>
                    <template v-else>
                        <div class="custom-control custom-checkbox" v-for="(dt,index) in data" v-bind:key="index">
                            <input type="checkbox" class="custom-control-input" v-model="selected" :id="`cb-${$attrs.vid}-${dt.value}`" :value="dt.value"  :disabled="disabled">
                            <label class="custom-control-label" :for="`cb-${$attrs.vid}-${dt.value}`">{{dt.label}}</label>
                        </div>
                    </template>
            </template>
            <template v-else>
               <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" class="custom-control-input" v-model="selected" :id="'simplecheckbox'+$attrs.vid" :value="true"  :disabled="disabled">
                    <label class="custom-control-label" :for="'simplecheckbox'+$attrs.vid">{{label}}</label>
                </div>
            </template>
        <template v-if="show_error == true">
            <span class="errors">{{errors[0]}}</span>
        </template>
        </div>
    </ValidationProvider>
</template>
<script>
import { ValidationProvider } from "vee-validate";
import { mdbInput, mdbFormInline } from "mdbvue";
export default{
    name : 'ThatsCheckbox',
    props : {
        rules : {
            type : [Object, String],
            default : ''
        },
        type : {
            type : String,
            default : 'text'
        },
        value: {
            type: [Array, Boolean, Number, String]
        },
        validated: {
            type: Boolean,
            default : true
        },

        data: {
            type: Array
        },
        show_error: {
            type: Boolean,
            default : false
        },

        labelClass : {
            type : String,
            default : 'col-md-3'
        },
        fieldClass : {
            type : String,
            default : 'col-md-9'
        },
        multiple : {
            type : Boolean,
            default : true
        },
        label : {
            type : String,
        },
        disabled : {
            type : Boolean,
            default : false
        },
        showLabel: {
            type: Boolean,
            default : true
        },
        horizontal: {
            type: Boolean,
            default : false
        },

    },
    components : {
        ValidationProvider,
        mdbInput,
        mdbFormInline,
    },

    data : ()=>({
        selected : [],
    }),


    watch: {
    // Handles internal model changes.
        selected(newVal) {
            if(this.multiple){
                this.$emit("input", newVal);
            }else{
                this.selected = (newVal) ? true : false
                this.$emit("input", newVal);

                // alert(this.selected)
                // alert(newVal)
            }
        },
    // Handles external model changes.
        value(newVal) {
            this.selected = newVal;
        }
    },
    created() {
        if (this.value) {
        this.selected = this.value;
        }
    }
}

</script>

<style scoped>


.errors{
    display: block!important;
}
</style>